import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface VisitorNavProps {
  isOpen: boolean;
  onClose: () => void;
}
export const VisitorNav = ({
  isOpen,
  onClose
}: VisitorNavProps) => {
  const {
    t
  } = useTranslation("nav");
  if (!isOpen) return null;
  return <nav className="flex flex-col h-full">
      <div className="flex flex-col space-y-1 pb-6">
        <Accordion type="single" collapsible className="w-full">
          {/* Platform Section */}
          <AccordionItem value="platform">
            <AccordionTrigger className="py-3 text-lg font-semibold text-gray-700">
              Platform
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-2 ml-4">
                <Link to="/platform/agent" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("agent")}</span>
                </Link>

                <Link to="/platform/data-integration" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("dataIntegration")}</span>
                </Link>

                <Link to="/platform/translations-analysis" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("translationsAnalysis")}</span>
                </Link>

                <Link to="/platform/legal-assistance" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("legalAssistance")}</span>
                </Link>

                <Link to="/platform/market-analysis-opportunities" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("marketAnalysis")}</span>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>

          {/* Virksomhed Section */}
          <AccordionItem value="company">
            <AccordionTrigger className="py-3 text-lg font-semibold text-gray-700">
              Virksomhed
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-2 ml-4">
                <Link to="/about" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("about")}</span>
                </Link>

                <Link to="/pricing" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("pricing")}</span>
                </Link>

                <Link to="/request-demo" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("requestDemo")}</span>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>

          {/* Support Section */}
          <AccordionItem value="support">
            <AccordionTrigger className="py-3 text-lg font-semibold text-gray-700">Webstedsoplysninger</AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-2 ml-4">
                <Link to="/legal/privacy-policy" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("privacyPolicy")}</span>
                </Link>

                <Link to="/legal/terms-of-service-danish" className="flex items-center space-x-2 px-2 py-2 text-base text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted" onClick={onClose}>
                  <span>{t("termsOfService")}</span>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </nav>;
};